<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      v-if="receiptTransfer.type === 2"
      v-can="'receipttransfer.update'"
      class="item"
      effect="dark"
      content="Módosítás"
      placement="top"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        style="margin-left: 5px;"
        @click="updateReceiptTransfer"
      />
    </el-tooltip>
    <el-tooltip
      v-if="receiptTransfer.type === 2"
      v-can="'receipttransfer.delete'"
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
    >
      <el-popover
        v-model="deleteConfirmVisible"
        placement="bottom"
        width="171"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteReceiptTransfer"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          :loading="deleteButtonLoader"
          size="mini"
          icon="el-icon-delete"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: ['receiptTransfer'],
    data() {
      return {
        deleteButtonLoader: false,
        deleteConfirmVisible: false,
      };
    },

    methods: {
      async deleteReceiptTransfer() {
        this.deleteButtonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('receiptTransfer/delete', this.receiptTransfer.id);
          this.$store.dispatch('receiptTransfer/fetchAll');
        } catch (e) {
          console.log(e)
        }
        this.deleteButtonLoader = false;
      },
      async updateReceiptTransfer() {
        this.$router.push('/representative-processes/receipt-transfers/update/' + this.receiptTransfer.id);
      },
    }
  };
</script>
